(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5271],{

/***/ 34614:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vaults",
      function () {
        return __webpack_require__(56207);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 56207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ vaults; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./src/v2/components/ui/label/index.tsx
var label = __webpack_require__(45306);
// EXTERNAL MODULE: ./src/v2/components/ui/label/stats/index.tsx + 1 modules
var stats = __webpack_require__(89301);
// EXTERNAL MODULE: ./src/v2/components/ui/loadSkeleton/index.tsx
var loadSkeleton = __webpack_require__(66820);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@mui/material/LinearProgress/LinearProgress.js
var LinearProgress = __webpack_require__(88441);
// EXTERNAL MODULE: ./node_modules/@mui/material/LinearProgress/linearProgressClasses.js
var linearProgressClasses = __webpack_require__(28962);
// EXTERNAL MODULE: ./src/components/theme/styles/colors.tsx
var colors = __webpack_require__(16381);
// EXTERNAL MODULE: ./src/config/protocol/index.ts + 3 modules
var protocol = __webpack_require__(87055);
;// CONCATENATED MODULE: ./src/v2/components/ui/progressBar/index.tsx





var ProgressBar = function(param) {
    var color = param.color, asset = param.asset, value = param.value, isLoading = param.isLoading;
    var progressBarColor = asset ? (0,protocol/* getAssetConfig */.nf)(asset).styles.gradient : color;
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinearProgress/* default */.Z, {
        variant: isLoading ? "indeterminate" : "determinate",
        sx: (_obj = {}, (0,_define_property/* default */.Z)(_obj, ".".concat(linearProgressClasses/* default.bar */.Z.bar), {
            background: progressBarColor
        }), (0,_define_property/* default */.Z)(_obj, "height", "2px"), (0,_define_property/* default */.Z)(_obj, "backgroundColor", colors/* white.15% */.ix["15%"]), _obj),
        value: value
    });
};

// EXTERNAL MODULE: ./src/components/hooks/useSession.ts
var useSession = __webpack_require__(87627);
// EXTERNAL MODULE: ./src/components/shared/link/index.tsx
var shared_link = __webpack_require__(67113);
// EXTERNAL MODULE: ./src/components/theme/styles/mixins.tsx
var mixins = __webpack_require__(52230);
// EXTERNAL MODULE: ./src/components/types.ts
var types = __webpack_require__(87493);
// EXTERNAL MODULE: ./src/components/utils/utils.tsx
var utils = __webpack_require__(63189);
// EXTERNAL MODULE: ./src/v2/components/ui/buttons/buttonWithIcon/index.tsx + 3 modules
var buttonWithIcon = __webpack_require__(52787);
// EXTERNAL MODULE: ./src/v2/components/ui/icons/assetTitle/index.tsx
var assetTitle = __webpack_require__(39960);
// EXTERNAL MODULE: ./src/components/hooks/protocol/_types.ts
var _types = __webpack_require__(29735);
// EXTERNAL MODULE: ./src/components/hooks/protocol/useVestaParameters.ts + 1 modules
var useVestaParameters = __webpack_require__(32806);
// EXTERNAL MODULE: ./src/components/hooks/protocol/vaults/useAllVaultData.ts
var useAllVaultData = __webpack_require__(90160);
// EXTERNAL MODULE: ./src/components/hooks/protocol/vaults/useVaultInterestRate.ts
var useVaultInterestRate = __webpack_require__(93427);
// EXTERNAL MODULE: ./src/components/hooks/protocol/vaults/useVaultRewardAPR.ts + 1 modules
var useVaultRewardAPR = __webpack_require__(62954);
// EXTERNAL MODULE: ./src/components/hooks/protocol/vaults/useVaultUserData.ts
var useVaultUserData = __webpack_require__(77184);
;// CONCATENATED MODULE: ./src/v2/components/layout/vault/vaultCard/defaultVaultCard/useDefaultVaultCard.ts






var useDefaultVaultCard = function(asset) {
    var ref;
    var ref1 = (0,useVestaParameters/* default */.ZP)(asset), _data = ref1.data, mcr = _data.mcr, minNetDebt = _data.minNetDebt, vstMintCap = _data.vstMintCap, isVestaParamsLoading = ref1.isLoading;
    var ref2 = (0,useVaultUserData/* default */.ZP)(asset), _data1 = ref2.data, status = _data1.vault.status, isVaultUserLoading = ref2.isLoading;
    var ref3 = (0,useVaultRewardAPR/* useVaultRewardAPR */.Y)(asset), apr = ref3.data, isAprLoading = ref3.isLoading;
    var ref4 = (0,useAllVaultData/* useAllVaultData */.V)(), responses = ref4.responses, isAnyVaultLoading = ref4.computed.isAnyVaultLoading;
    var ref5 = (0,useVaultInterestRate/* useVaultInterestRate */.T)(asset), vrr = ref5.data, isInterestLoading = ref5.isLoading;
    return {
        mcr: mcr,
        apr: apr,
        vrr: vrr,
        minimumBorrow: minNetDebt,
        mintCap: vstMintCap,
        vaultOpen: status !== _types/* ETroveStatusGraph.NULL */.R.NULL && status !== _types/* ETroveStatusGraph.CLOSED_BY_OWNER */.R.CLOSED_BY_OWNER,
        currentAssetDebt: Number(((ref = responses[asset].data.vault.currentAssetSystemState) === null || ref === void 0 ? void 0 : ref.totalDebt) || "0"),
        isVestaParamsLoading: isVestaParamsLoading,
        isVaultUserLoading: isVaultUserLoading,
        isAprLoading: isAprLoading,
        isAnyVaultLoading: isAnyVaultLoading,
        isInterestLoading: isInterestLoading
    };
};

;// CONCATENATED MODULE: ./src/v2/components/layout/vault/vaultCard/defaultVaultCard/index.tsx

















var DefaultVaultCard = function(param) {
    var asset = param.asset;
    var ref = useDefaultVaultCard(asset), mcr = ref.mcr, apr = ref.apr, vrr = ref.vrr, mintCap = ref.mintCap, vaultOpen = ref.vaultOpen, currentAssetDebt = ref.currentAssetDebt, isVestaParamsLoading = ref.isVestaParamsLoading, isVaultUserLoading = ref.isVaultUserLoading, isAprLoading = ref.isAprLoading, isAnyVaultLoading = ref.isAnyVaultLoading, isInterestLoading = ref.isInterestLoading;
    var isConnected = (0,useSession/* useSession */.k)().isConnected;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            flexShrink: 0,
            padding: "32px",
            width: "100%",
            maxWidth: [
                "inital",
                "341.33px"
            ],
            borderRadius: "8px",
            background: colors/* black.45% */.Sn["45%"],
            border: "1px solid ".concat(colors/* black.15% */.Sn["15%"]),
            backgroundClip: "padding-box",
            position: "relative",
            "&:hover": (0,_object_spread/* default */.Z)({}, mixins/* secondaryBorder */.ck)
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            sx: {
                display: "flex",
                flexDirection: "column",
                gap: "32px"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(assetTitle/* AssetTitle */.e, {
                    secondary: true,
                    asset: asset,
                    active: vaultOpen,
                    sx: {
                        mb: "24px"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    sx: (0,_object_spread/* default */.Z)({}, (0,mixins/* columnGap */.e$)(24)),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            direction: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* GenericInfoLabel */.P, {
                                        variant: "vertical",
                                        labelTitle: "MCR",
                                        labelValueVariant: "label2",
                                        labelValue: (0,utils/* displayFormatUnits */.Hz)({
                                            value: mcr,
                                            displayType: types/* EDisplayType.Percent */.co.Percent,
                                            decimal: 0
                                        }),
                                        isLoading: isVestaParamsLoading,
                                        skeletonProps: {
                                            height: "24px"
                                        }
                                    })
                                }),
                                !!apr && /*#__PURE__*/ (0,jsx_runtime.jsx)(stats/* LabelApr */.i0, {
                                    variant: "header",
                                    apr: apr
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            sx: (0,_object_spread/* default */.Z)({}, (0,mixins/* columnGap */.e$)(8)),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressBar, {
                                    asset: asset,
                                    value: currentAssetDebt / mintCap * 100 || 0,
                                    isLoading: isAnyVaultLoading || isVestaParamsLoading
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* GenericInfoLabel */.P, {
                                    labelTitle: "MINTED",
                                    labelValueVariant: "body3",
                                    labelValue: "".concat((0,utils/* displayFormatUnits */.Hz)({
                                        value: currentAssetDebt,
                                        displayType: types/* EDisplayType.ShortVST */.co.ShortVST,
                                        decimal: 0
                                    }), " of ").concat((0,utils/* displayFormatUnits */.Hz)({
                                        value: mintCap,
                                        displayType: types/* EDisplayType.ShortVST */.co.ShortVST,
                                        decimal: 0
                                    })),
                                    isLoading: isAnyVaultLoading || isVestaParamsLoading
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                            sx: {
                                margin: 0
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            sx: {
                                display: "flex",
                                flexDirection: "column",
                                gap: "16px"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* GenericInfoLabel */.P, {
                                    labelValue: (0,utils/* displayFormatUnits */.Hz)({
                                        value: vrr,
                                        displayType: types/* EDisplayType.Percent */.co.Percent
                                    }),
                                    labelTitle: "VESTA REFERENCE RATE",
                                    isLoading: isInterestLoading
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* GenericInfoLabel */.P, {
                                    labelValue: (0,utils/* displayFormatUnits */.Hz)({
                                        value: apr || NaN,
                                        displayType: types/* EDisplayType.Percent */.co.Percent
                                    }),
                                    labelTitle: "YIELD ON COLLATERAL",
                                    isLoading: isAprLoading
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(loadSkeleton/* LoadSkeleton */.n, {
                    isLoading: isVaultUserLoading && isConnected,
                    height: 42,
                    width: "100%",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_link/* default */.ZP, {
                        href: "/vaults/".concat(asset),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(buttonWithIcon/* ButtonWithIcon */.A, {
                            variant: vaultOpen ? "primaryGradient" : undefined,
                            children: vaultOpen ? "EXISTING VAULT" : "CREATE VAULT"
                        })
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/v2/components/ui/appGrid/index.tsx
var appGrid = __webpack_require__(36804);
// EXTERNAL MODULE: ./src/v2/components/ui/appPageWrapper/index.tsx + 1 modules
var appPageWrapper = __webpack_require__(24171);
// EXTERNAL MODULE: ./src/v2/components/ui/background/index.tsx
var background = __webpack_require__(1065);
// EXTERNAL MODULE: ./src/v2/components/ui/textBlock/index.tsx + 1 modules
var textBlock = __webpack_require__(34138);
;// CONCATENATED MODULE: ./src/pages/vaults/index.tsx








function Vaults() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(appPageWrapper/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(background/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(appGrid/* default */.Z, {
                sx: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "48px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(textBlock/* TextBlock */.a, {
                        primaryText: "Vesta Vaults",
                        secondaryText: "Maximize the potential of your crypto assets.",
                        descriptionText: "Vesta Finance allows you to borrow our collaterized stablecoin VST against supported crypto assets with no interest rate."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                        sx: {
                            margin: 0
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        sx: {
                            display: "flex",
                            alignItems: "center",
                            gap: "32px",
                            flexWrap: "wrap",
                            justifyContent: [
                                "center",
                                "start"
                            ]
                        },
                        children: protocol/* ActiveCollateralAssets.map */.HJ.map(function(asset) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultVaultCard, {
                                asset: asset
                            }, asset);
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var vaults = (Vaults);


/***/ }),

/***/ 1065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99226);
/* harmony import */ var _components_hooks_useSidebarWidth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33468);




var Background = function(param) {
    var _height = param.height, height = _height === void 0 ? "100vh" : _height;
    var sidebarWidth = (0,_components_hooks_useSidebarWidth__WEBPACK_IMPORTED_MODULE_2__/* .useSidebarWidth */ .O)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        sx: {
            position: "fixed",
            height: height,
            width: {
                xs: "100vw",
                sm: "calc(100vw - ".concat(sidebarWidth, "px)")
            },
            zIndex: "-1",
            opacity: 1,
            left: {
                xs: 0,
                sm: "".concat(sidebarWidth, "px")
            },
            background: "url(/v2/backgrounds/blobs_bg.svg)",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat"
        },
        children: " "
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Background);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [475,7050,7959,2251,7909,9774,2888,179], function() { return __webpack_exec__(34614); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);